<template>
  <LayoutContainer :props="props">
    <div class="first-screen-container">
      <div class="label">{{ props.text1 }}</div>
      <div class="amount">
        <span class="rmb">
          <b class="unit">¥</b>
          <b class="num">
            {{ homeInfo.baseAwardAmount }}
          </b>
        </span>
        <span class="tag" v-if="props.tag">{{ props.tag }}</span>
      </div>
      <div class="base-award">{{ props.baseAward }}</div>
      <div class="time">
        <template v-if="+homeInfo.activityState <= 1">活动时间：{{ showText }}</template>

        <template v-if="+homeInfo.activityState === 2">
          <template v-if="moreThan7day">
            {{ showText }}
          </template>
          <template v-else>
            {{ day }}天
            <span>{{ showText }}</span>
            后活动结束
          </template>
        </template>

        <template v-if="+homeInfo.activityState >= 3">下次早点来呦～</template>
      </div>
      <div class="btn-wrap" id="first-screen-btn">
        <img :style="`width: ${px2rem(props.imgwidth)}`" :src="props.src1" v-if="+homeInfo.activityState <= 1" />
        <img :style="`width: ${px2rem(props.imgwidth)}`" :src="props.src2" v-else-if="+homeInfo.activityState > 2" />
        <img
          class="img"
          :style="`width: ${px2rem(props.imgwidth)}`"
          :src="props.src"
          @click="openShare"
          v-else-if="+homeInfo.activityState === 2"
        />
      </div>
    </div>
  </LayoutContainer>
</template>

<script>
import dayjs from 'dayjs';
import { mapState } from 'vuex';
import { px2rem } from '@/utils/utils';
import { env } from '@/config';

export default {
  name: 'kaer-first-screen',
  props: {
    componentId: String,
    props: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      day: 0,
      showText: '00:00:00',
      moreThan7day: false
    };
  },
  computed: {
    ...mapState({
      homeInfo: (state) => state.share.homeInfo
    })
  },
  watch: {
    homeInfo: {
      immediate: true,
      handler(newVal) {
        if (newVal.countDown) {
          if (+newVal.activityState <= 1) {
            this.showText = `${dayjs(this.homeInfo.startTime).format('MM.DD HH:mm')} - ${dayjs(
              this.homeInfo.endTime
            ).format('MM.DD HH:mm')}`;
            return;
          }

          if (+newVal.activityState >= 3) return;

          newVal && this.formatCountDown(newVal.countDown);
        }
      }
    }
  },
  methods: {
    px2rem,
    async openShare() {
      this.uploadData(this.$teleCodes.clickInvite, 'event', { kaerComponentId: this.componentId });

      if (env !== 'mock') {
        await this.adapt.login();

        // 根据是否存在邀请人信息判断是否登录
        if (!this.homeInfo.inviterUserId) {
          await this.adapt.reLogin();
          return;
        }
      }
      this.$bus.$emit('openShareDialog');
    },
    formatCountDown(timestamp) {
      this.clearInverval();
      this.timer = setInterval(() => {
        timestamp -= 1;
        if (timestamp <= 0) {
          this.clearInverval();
          this.$store.dispatch('fetchHomeInfo', {
            bizId: 'C_TERMINAL',
            activityId: this.homeInfo.activityId
          });
        }
        this.day = parseInt(timestamp / 60 / 60 / 24, 10);

        this.moreThan7day = this.day >= 7;
        if (this.day >= 7) {
          this.showText = `${dayjs(this.homeInfo.startTime).format('MM.DD HH:mm')} - ${dayjs(
            this.homeInfo.endTime
          ).format('MM.DD HH:mm')}`;
          return;
        }

        let hours = parseInt((timestamp / 60 / 60) % 24, 10);
        let minutes = parseInt((timestamp / 60) % 60, 10);
        let seconds = parseInt(timestamp % 60, 10);
        if (hours < 10) hours = `0${hours}`;
        if (minutes < 10) minutes = `0${minutes}`;
        if (seconds < 10) seconds = `0${seconds}`;
        this.showText = `${hours}:${minutes}:${seconds}`;
      }, 1000);
    },
    clearInverval() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }
};
</script>

<style scoped lang="less">
.first-screen-container {
  text-align: center;
  margin: 0 auto;
  .label {
    height: 14px;
    font-size: 14px;
    font-weight: 400;
    color: #595959;
    line-height: 14px;
    margin-bottom: 8px;
  }

  .amount {
    font-weight: 600;
    color: #f65425;

    letter-spacing: 2px;
    text-align: center;
    white-space: nowrap;
    margin-bottom: 60px;
    display: flex;
    align-items: center;
    justify-content: center;

    .rmb {
      font-size: 0;
      font-size: 32px;
      line-height: 32px;
    }
    .num {
      font-size: 53px;
      line-height: 53px;
      display: inline-block;
    }

    .unit {
      font-size: 32px;
    }
    .tag {
      width: 16px;
      background: #f65425;
      border-radius: 4px;
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      color: #ffffff;
      line-height: 12px;
      word-break: break-word;
      display: inline-block;
      white-space: pre-wrap;
      padding: 2px;
      vertical-align: text-bottom;
      margin-left: 10px;
    }
  }

  .base-award {
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 1px;
    color: #fff7e6;
  }

  .time {
    margin-top: 20px;
    height: 32px;
    line-height: 32px;
    background: url('~@/assets/share/shadowbox.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;

    span {
      margin: 0 3px;
    }
  }

  .btn-wrap {
    margin-top: 12px;

    .img {
      animation: invite 1.4s ease-in-out infinite;
    }
  }

  @keyframes invite {
    0% {
      transform: scale(0.9);
    }

    50% {
      transform: scale(1);
    }
    100% {
      transform: scale(0.9);
    }
  }
}
</style>
